export enum EnumUserSharedFormField {
  type = 'type',
  profitSharing = 'profitSharing',
  recommendedMinDepositAmount = 'recommendedMinDepositAmount',
  makeMinDepositAmountRequired = 'makeMinDepositAmountRequired',
  marginStopCopyLevel = 'marginStopCopyLevel',
  stopCopyViaMarginLevel = 'stopCopyViaMarginLevel',
  percentageLossStopCopyLevel = 'percentageLossStopCopyLevel',
}
